import { CreateButton } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC } from 'react';
import { HeaderTab } from '../../_components/HeaderTab';
import { SnapshotTable } from '../_components/SnapshotTable';
import { useSnapshotDrawerState } from '../_components/upset-drawer/SnapshotDrawerStateProvider';
import { SnapshotFormDrawer } from '../_components/upset-drawer/SnapshotFormDrawer';

export const SnapshotsPage: FC = () => {
  const { setDrawerState } = useSnapshotDrawerState();

  return (
    <>
      <HeaderTab
        type="snapshots"
        tabBarExtraContent={
          <TenantManagerResourceGuard onlyEdit>
            <CreateButton
              onCreate={() => {
                setDrawerState({ open: true, isEditing: false });
              }}
            />
          </TenantManagerResourceGuard>
        }
      />
      <SnapshotTable />
      <SnapshotFormDrawer />
    </>
  );
};
